// extracted by mini-css-extract-plugin
export default {"statisticPreview":"StatisticPreview_statisticPreview__OTTPX","title":"StatisticPreview_title__vc01Y","timer":"StatisticPreview_timer__vkZiW"};